import React from "react";
import PropTypes from "prop-types";
import {
  Select,
  MenuItem,
  Chip,
  FormControl,
  InputLabel,
  // OutlinedInput,
} from "@mui/material";
import { styled, useTheme } from "@mui/system";

const CustomSelect = styled(Select)(({ theme }) => ({
  backgroundColor: "transparent",
  height: "56px",
  width: "100%",
  minWidth: "100px",
  // border: 1,
  // borderColor: theme.palette.custom.borderColor,
  // borderRadius: "11px",
  // "& .MuiOutlinedInput-notchedOutline": {
  //   borderColor: theme.palette.custom.borderColor,
  // },
  // "&:hover .MuiOutlinedInput-notchedOutline": {
  //   borderColor: theme.palette.custom.borderColor,
  // },
  // "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
  //   borderColor: theme.palette.custom.borderColor,
  // },
  // "& .MuiList-root": {
  //   backgroundColor: theme.palette.custom.inputBackgroundColor,
  // },
  // "& .MuiChip-root": {
  //   margin: "4px",
  // },
  "&:hover": {
    backgroundColor: theme.palette.custom.buttonHoverColor,
    color: theme.palette.custom.buttonHoverTextColor,
    boxShadow: "none",
  },
}));
const MultiSelectWithChips = ({
  label,
  menuItems,
  selectedValues,
  onChange,
}) => {
  const theme = useTheme();

  return (
    <FormControl
      fullWidth
      variant="outlined"
      style={{
        border: "1px solid",
        borderColor: theme.palette.custom.borderColor,
        borderRadius: "11px",
      }}
    >
      <InputLabel
        shrink={false}
        sx={{ fontSize: "10px", top: "-14px", left: "-6px" }}
      >
        {label}
      </InputLabel>
      <CustomSelect
        multiple
        value={selectedValues}
        // onChange={onChange}
        // input={<OutlinedInput label={label} />}
        renderValue={(selected) => (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {selected?.map((value) => {
              return (
                <Chip
                  key={value.name}
                  label={value.name}
                  sx={{ borderRadius: 1 }}
                />
              );
            })}
          </div>
        )}
      >
        {menuItems?.map((item) => (
          <MenuItem
            onClick={() => onChange(item)}
            key={item.name}
            value={item.name}
          >
            {item.name}
          </MenuItem>
        ))}
      </CustomSelect>
    </FormControl>
  );
};

MultiSelectWithChips.propTypes = {
  label: PropTypes.string.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default MultiSelectWithChips;
